/**
 * Wallet Comparison Table - Mobile Expand/Collapse Functionality
 */ 

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWalletComparison);
  } else {
    initWalletComparison();
  }

  function initWalletComparison() {
    const toggleBtn = document.getElementById('toggleTableBtn');
    const mobileTable = document.getElementById('mobile-comparison-table');
    
    if (!toggleBtn || !mobileTable) {
      return;
    }

    const mobileTableWrapper = mobileTable.closest('.mobile-table');
    const toggleText = toggleBtn.querySelector('.toggle-text');

    toggleBtn.addEventListener('click', function() {
      const isExpanded = mobileTableWrapper.classList.contains('expanded');
      
      if (isExpanded) {
        mobileTableWrapper.classList.remove('expanded');
        toggleText.textContent = 'SHOW MORE';
        toggleBtn.setAttribute('aria-expanded', 'false');
      } else {
        mobileTableWrapper.classList.add('expanded');
        toggleText.textContent = 'SHOW LESS';
        toggleBtn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId.includes('wallet-comparison')) {
        initWalletComparison();
      }
    });
  }
})();

